import { useTranslation } from "react-i18next";
import { MdFlip, MdOutlinePause, MdOutlinePlayArrow, MdRestartAlt } from "react-icons/md";

import useAuth from "../../../../hooks/useAuth";
import Button from "../../../Button";

const PythonHeader = ({
  onRunCode,
  onStopCode,
  isLoading,
  isRunning,
  setIsHorizontal,
  isHorizontal,
  resetPythonCodeAndRunCode = () => {},
  hasCodeContent = () => {},
  isTeacher = false,
}) => {
  const { t } = useTranslation();
  const user = useAuth();

  return (
    <div className="relative mb-4 flex justify-between">
      {user.role === "student" ? (
        <>
          <div className="min-w-28"></div>
          <Button
            color={isRunning ? "red" : "blue"}
            iconLeft={isRunning ? <MdOutlinePause size={20} /> : <MdOutlinePlayArrow size={20} />}
            onClick={() => (isRunning ? onStopCode() : onRunCode())}
            label={isRunning ? t("stop") : t("run")}
            className="absolute left-3 top-[67vh] z-50 min-w-28"
          />
        </>
      ) : (
        <Button
          color={isRunning ? "red" : "blue"}
          iconLeft={isRunning ? <MdOutlinePause size={20} /> : <MdOutlinePlayArrow size={20} />}
          onClick={() => (isRunning ? onStopCode() : onRunCode())}
          label={isRunning ? t("stop") : t("run")}
          className="min-w-28"
        />
      )}
      <div className="flex gap-2">
        {!isTeacher && (
          <Button
            iconLeft={<MdRestartAlt size={20} />}
            onClick={resetPythonCodeAndRunCode}
            label={t("reset_code")}
            className="min-w-28"
            disabled={!hasCodeContent()}
          />
        )}
        <Button
          className={user.role === "student" ? "mb-0" : ""}
          icon={
            <MdFlip
              size={user.role === "student" ? 26 : 22}
              style={{
                transform: isHorizontal ? "rotate(0deg)" : "rotate(90deg)",
                transition: "transform 0.3s ease",
              }}
            />
          }
          onClick={() => setIsHorizontal(!isHorizontal)}
        />
      </div>
    </div>
  );
};

export default PythonHeader;
